import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Slide,
} from '@mui/material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Iconify from '../common/iconify.component';
import Loading from '../table-elements/loading.component';
import { CONTENT_ALIAS } from '../../config/const.config';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ListSequenceVideos = ({
  handleOnDragEndVideos,
  handleUpdateVideosSequence,
  action,
  selectedChannel,
  channelVideosList,
  vidOptions,
  handleCloseDialog,
}) => (
  
  <Dialog
    open={action.show}
    aria-describedby="channel-category-videos"
    aria-labelledby="channel-category-videos"
    TransitionComponent={Transition}
    fullWidth
    maxWidth="md"
  >
    <DialogTitle>{`Reorder ${CONTENT_ALIAS.CONTENT} Sequence - ${selectedChannel.title}`}</DialogTitle>

    <DialogContent dividers>
      {vidOptions.loading && <Loading />}

      {!vidOptions.loading && (
        <DragDropContext onDragEnd={handleOnDragEndVideos}>
          <Droppable droppableId="videos">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {!vidOptions.loading &&
                  channelVideosList.length > 0 &&
                  channelVideosList.map((video, index) => (
                    <Draggable
                      key={`video-${video.id}`}
                      draggableId={video.id.toString()}
                      index={index}
                    >
                      {(provide) => (
                        <Card
                          sx={{
                            marginBottom: '5px',
                          }}
                          ref={provide.innerRef}
                          {...provide.draggableProps}
                          {...provide.dragHandleProps}
                        >
                          <CardContent
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              paddingY: '12px',
                              '&:last-child': {
                                paddingBottom: '12px',
                              },
                            }}
                          >
                            <div>{video.title || video.name}</div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  marginLeft: 10,
                                }}
                              >
                                <Iconify icon="ic:round-table-rows" />
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      )}
                    </Draggable>
                  ))}

                {!vidOptions.loading && channelVideosList.length === 0 && (
                  <Paper
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    No data available.
                  </Paper>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </DialogContent>

    <DialogActions>
      <Button
        onClick={handleUpdateVideosSequence}
        disabled={
          channelVideosList.length === 0 || channelVideosList.length === 1
        }
        variant="contained"
      >
        Save
      </Button>
      <Button onClick={handleCloseDialog} variant="contained">Cancel</Button>
    </DialogActions>
  </Dialog>
);

ListSequenceVideos.propTypes = {
  handleOnDragEndVideos: PropTypes.func.isRequired,
  handleUpdateVideosSequence: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  selectedChannel: PropTypes.object.isRequired,
  channelVideosList: PropTypes.array.isRequired,
  vidOptions: PropTypes.object.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

export default ListSequenceVideos;
